import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import Products from './pages/Products';
import StockHub   from './pages/StockHub';
import StockEntry from './pages/StockEntry';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import Profitability from './pages/Profitability';
import Financials from './pages/Financials';
import CompanyFinance from './pages/CompanyFinance';
import ActivityLog from './pages/ActivityLog';
import SupplyManagement from './pages/SupplyManagement';
import DeliveryTracking from './pages/DeliveryTracking';
import ScanInbound from './pages/ScanInbound';
import NeedScan from './pages/NeedScan';
import AcceptInvite from './pages/AcceptInvite';
import Login from './pages/Login';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('ozon_token');
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/orders/:id" element={<OrderDetail />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/stock-hub"   element={<StockHub />} />
                  <Route path="/stock-entry" element={<StockEntry />} />
                  <Route path="/settings"         element={<Settings />} />
                  <Route path="/analytics"       element={<Analytics />} />
                  <Route path="/profitability"   element={<Profitability />} />
                  <Route path="/financials"      element={<Financials />} />
                  <Route path="/company-finance" element={<CompanyFinance />} />
                  <Route path="/activity-log"   element={<ActivityLog />} />
                  <Route path="/supply-management" element={<SupplyManagement />} />
                  <Route path="/delivery-tracking" element={<DeliveryTracking />} />
                  <Route path="/scan-inbound"      element={<ScanInbound />} />
                  <Route path="/need-scan"         element={<NeedScan />} />
                </Routes>
              </Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
